import axios from '@/axios';

export default {
	namespaced: true,

	state: {
		sections: [],
	},

	actions: {
		async fetchAllSections({ state, commit }, cash = false) {
			return state.sections.length && !cash
				? state.sections
				: axios.get('/Sections').then(({ data }) => {
						commit('root', data);
						return data;
				  });
		},
		async fetchEmployeesBySection(_, { sectionId }) {
			return axios.get('/Sections/' + sectionId + '/Employees', { sectionId }).then(({ data }) => data);
		},
		async addSection(_, { id, name, parentId, sectionManagerId, employeeCount }) {
			return id
				? axios.put('/Sections/' + id, { name: name, parentId: parentId, sectionManagerId: sectionManagerId, employeeCount: employeeCount })
				: axios.post('/Sections/', { name: name, parentId: parentId, sectionManagerId: sectionManagerId, employeeCount: employeeCount });
		},
		async deleteSection(_, id) {
			return axios.delete('/Sections/' + id).then(({ data }) => data);
		},
	},

	mutations: {
		root(state, sections) {
			state.sections = sections;
		},
	},

	getters: {
		getSectionById: state => id => state.sections.find(c => c.id === id)
	}
};
